





































import store from '@/store'
import ApiClient from '@/js/api.js'
import ManageRow from '@/views/organisms/ManageRow.vue'
import ManageTemplate from '@/views/templates/ManageTemplate.vue'
import BackButton from '@/views/atoms/BackButton.vue'
import YellowButton from '@/views/atoms/YellowButton.vue'
import Global from '@/js/global.js'

export default
    name: 'SendConfirmForm'
    components: {
        ManageRow
        ManageTemplate
        BackButton
        YellowButton
    }

    data: () =>
        confirmData: {}
        pref_name: ''
        pass: ''
        loginCheck: false
        url: '/user/edit'

    created: () ->
        @confirmData = store.getters.getPostParam
        @loginCheck = await store.getters.isLogin
        if !@loginCheck
            len = @confirmData.password.length
            for i in [0...len]
                @pass += '・'
            @url = '/user/append'
        if Object.keys(@confirmData).length == 0
            @$router.push @url
        else
            api = new ApiClient()
            data = await api.post('/tool/zipcode')
            @pref_name = data.pref_name

    methods: {
        go_back: (e) ->
            @$emit('go_back')
        execute_append_send: (e) ->
            api = new ApiClient()
            data = await api.post('/member/user/save')
            if data.errors.length == 0
                store.dispatch('setLoginStatus', true)
            if $cookies.isKey('user_append_url')
                @$router.push $cookies.get('user_append_url')
            else
                @$router.push '/'
        gender: (code) ->
            gender = Global.getGender()
            return gender[code]
    }
    search_address: (address) ->
        @prefID = address.pref_id + ''
        @prefValue = address.shiku_name + address.choiki_name
